import React from 'react'
import { Typography, useTheme, makeStyles } from '@material-ui/core'

export const HeroImage = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <div className={classes.container}>
      <div className={classes.overlay}>
        <div className={classes.content}>
          <h3 className={classes.text}>Kör längre</h3>
          <h3 className={classes.text}><span className={classes.highlighttext}>Serva</span> bilen</h3>
        </div>
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    width: '100%', 
    height: '60vh', 
    backgroundImage: "url('https://images.pexels.com/photos/398077/pexels-photo-398077.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260')",
    backgroundSize: 'cover', 
    objectFit: 'cover',
    backgroundPosition: 'top center'
  },
  overlay: {
    display: 'flex',
    backgroundColor: 'rgba(0,0,0,.5)',
    width: '100%',
    height: '60vh',
    alignItems: 'center',
    textAlign: 'center',
    objectFit: 'cover',
  },
  content: {
    maxWidth: '375px',
    margin: '0 auto'
  },
  text: {
    color: 'white',
    fontSize: '3rem',
    margin: 0,
    padding: 0
  },
  highlighttext: theme => ({
    color: theme.palette.action.main,
    fontSize: '3rem',
    margin: 0,
    padding: 0
  })
  
})